import { render, staticRenderFns } from "./AgencyFees.vue?vue&type=template&id=3c2fcf16&"
import script from "./AgencyFees.vue?vue&type=script&lang=js&"
export * from "./AgencyFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports